import { User } from '@/api' 

export default {
  namespaced: true,

  state: ({
    currentUser: null,
    currentDevice: null,
    users: []
    // User DIFINITION
    // id: self.id,
    // name: self.name,
    // account_name: self.account_name,
    // email: self.email,
    // nb_id: self.nb_id,
    // nb_author_id: self.nb_author_id,
    // # nb_organization_id: self.nb_organization_id,
    // nb_organization_id: org_id,
    // narrative_phone_id: self.narrative_phone_id,
    // description: self.description,
    // icon_img_path: self.icon_img_path,
    // user_state: self.state,
    // user_state_jp: self.state_jp,
    // ios_zoom_available: ios_zoom_available,
    // android_zoom_available: android_zoom_available,
    // zoom_id: zoom_id,
    // own_signin: own_signin
    // theme_color: self.theme_color,
    //
    // ACCOUNT_BEFORE_VALIDATION = 0
    // ACCOUNT_IN_PROGRESS = 1
    // ACCOUNT_AVAILABLE = 2
    // ACCOUNT_SUSPEND = 3
    //
    // PhoneDevice DIFINITION
    // id: self.id,
    // phone_device_id: self.phone_device_id,
    // phone_device_description: self.phone_device_description,
    // phone_device_token: self.phone_device_token,
    // push_target: self.push_target,
    // created_at: self.created_at,
    // call_state: self.call_state,
    // available: self.available
  }),

  mutations: {
    setCurrentUser (state, payload) {
      state.currentUser = payload
    },

    setCurrentDevice (state, payload) {
      state.currentDevice = payload
    },

    setCurrentSignin (state, payload) {
      state.currentUser = payload.user
      if (payload.phone_device) {
        state.currentDevice = payload.phone_device
      }
    },

    setUsers (state, payload) {
      state.users = payload
    }
  },

  getters: {
    activeUsers: state => {
      return state.users.filter((user) => user.user_state === 2)
    }
  },

  actions: {
    fetchCurrentSignin ({ commit }) {
      return User.fetchCurrentSignin().then(res => {
        console.log('on store/modules/User')
        console.log(res)
        commit('setCurrentSignin', res.data)
      }).catch(() => {
        commit('setCurrentSignin', {})
      })
    },

    fetchAvailableUsers ({ commit }) {
      return User.fetchAvailabeUsers().then(res => {
        commit('setUsers', res.data.users)
      }).catch(() => {
        commit('setUsers', [])
      })
    },

    fetchByNarrativePhoneID (context, payload) {
      return User.fetchByNarrativePhoneID(payload).then(res => {
        console.log(res)
        return res.data.user
      })
    },

    signin (context, payload) {
      return User.signin(payload).then(res => {
        // dispatch('fetchCurrentSignin')
        // dispatch('fetchAvailableUsers')
        console.log('in module')
        console.log(res)
        return res
      })
    },

    switchAccount ({ dispatch }, payload) {
      return User.switchAccount({ accountName: payload }).then(res => {
        console.log(res)
        dispatch('fetchCurrentSignin')
      })
    },

    createWithDevice (context, payload) {
      return User.createWithDevice(payload).then(res => {
        console.log(res)
        return {
          user_id: res.data.user.id,
          user_name: res.data.user.name,
          user_account_name: res.data.user.account_name,
          user_email: res.data.user.email,
          narrative_phone_id: res.data.user.narrative_phone_id,
          ios_zoom_available: res.data.user.ios_zoom_available,
          android_zoom_available: res.data.user.android_zoom_available,
          phone_device_id: res.data.phone_device.phone_device_id,
          phone_device_target: res.data.phone_device.push_target,
          phone_device_authenticate_token: res.data.phone_device.device_authenticate_token
        }
      })
    },

    accountResult (context, payload) {
      return User.account_result(payload).then(res => {
        return res
      })
    },

    relateNBAccount({ dispatch }, payload) {
      return User.relateNBAccount(payload).then(res => {
        console.log(res)
        dispatch('fetchCurrentSignin')
        dispatch('fetchAvailableUsers')
      })
    },

    update({ dispatch }, payload) {
      return User.update({ formData: payload }).then(res => {
        console.log(res)
        dispatch('fetchCurrentSignin')
        dispatch('fetchAvailableUsers')
        return res
      })
    },

    updatePassword({ dispatch }, payload) {
      return User.updatePassword({ password: payload.password, passwordConfirmation: payload.passwordConfirmation }).then(res => {
        console.log(res)
        dispatch('fetchCurrentSignin')
        dispatch('fetchAvailableUsers')
      })
    },

    destroy ({ dispatch }) {
      return User.destroy().then(res => {
        console.log(res)
        // let switchTarget = null
        // for(let user of state.users) {
        //   if (user.id !== state.currentUser.id) {
        //     console.log('in destroy loop..')
        //     console.log(switchTarget)
        //     console.log(state.currentUser)
        //     switchTarget = user
        //     break
        //   }
        // }
        // console.log(switchTarget)
        // if (switchTarget) {
        //   dispatch('switchAccount', switchTarget.account_name)
        // }
        dispatch('fetchAvailableUsers')
      })
    },

    deleteDeviceRelation ({ dispatch }, payload) {
      return User.delete_device_relation({ targetDeviceID: payload }).then(res => {
        console.log(res)
        // let switchTarget = null
        // for(let user of state.users) {
        //   if (user.id !== state.currentUser.id) {
        //     switchTarget = user
        //     break
        //   }
        // }
        // if (switchTarget) {
        //   dispatch('switchAccount', switchTarget.account_name)
        // }
        dispatch('fetchAvailableUsers')
      })
    },

    nameAvailable (context, payload) {
      return User.nameAvailable({ accountName: payload }).then(res => {
        console.log(res)
        return { available: res.data.available, message: res.data.message }
      })
    },

    sendMailValidation (context, payload) {
      console.log('in modules, user.sendMailValidation....')
      return User.sendMailValidation(payload)
    },

    signout ({commit}) {
      console.log('gonna signout')
      return User.signout().then(() => {
        commit('setCurrentSignin', {})
      })
    }

  }
}